import { CommonModule, NgFor } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  NgbModal,
  NgbModalModule,
  NgbTooltipModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { OrderManagementService } from '../../../Services/order-management.service';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxSpinnerService } from 'ngx-spinner';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';

@Component({
  selector: 'app-process-order',
  standalone: true,
  imports: [
    NgFor,
    CommonModule,
    NgbModalModule,
    NgbTooltipModule,
    NgbPaginationModule,
    ReactiveFormsModule,
    ToastrModule,
    NgxSpinnerModule,
  ],
  templateUrl: './process-order.component.html',
  styleUrl: './process-order.component.css',
})
export class ProcessOrderComponent implements OnInit {
  @ViewChild('confirmationModal') confirmationModal!: TemplateRef<any>;
  @ViewChild('detailModel') detailsModal!: TemplateRef<any>;

  isPaid: boolean = false;
  selectedRow: any;
  // Pagination Variables
  currentPage: number = 1;
  pageSize: number = 5; // Number of items per page
  pagedTableData: any[] = [];
  approveOrderList: any;
  originalTableData: any;
  requestorName: any;
  selectedOrderId: any;
  selectedRequestorId: any;
  orderForm: FormGroup;
  orderStatus: any;

  cities: any[] = [];

  uniqueCities: any[] = [];

  // Handle page change event
  onPageChange(page: number) {
    this.currentPage = page;
  }

  get pagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    const end = start + this.pageSize;
    return this.approveOrderList?.slice(start, end);
  }

  tableHeader = [
    'Order ID',
    'Requestor Type',
    'Requestor Name',
    'Requestor mobile no',
    'Request Date',
    'Scheduled Date',
    'City',
    'Order Status',
    'Action',
  ];

  tableData: any = [
    {
      requestorId: 'AB-001',
      requestorType: 'Individual requestor',
      requestorName: 'Arun',
      requestorMobile: '9876543210',
      requestDate: '2024-02-15',
      scheduledDate: '2024-03-10',
      city: 'New york',
      zone: 'AlMadinah',
      paymentStatus: 'Yet to receive',
      orderStatus: 'Order pending',
    },
    {
      requestorId: 'AB-002',
      requestorType: 'Corporate requestor',
      requestorName: 'Manoj',
      requestorMobile: '9876543210',
      requestDate: '2024-02-01',
      scheduledDate: '2024-03-15',
      city: 'Chicago',
      zone: 'AlAndulas',
      paymentStatus: 'Payment Received',
      orderStatus: 'Order Placed',
    },
    {
      requestorId: 'AB-003',
      requestorType: 'Individual requestor',
      requestorName: 'Gugan',
      requestorMobile: '9876543210',
      requestDate: '2024-07-05',
      scheduledDate: '2024-08-10',
      city: 'Francisco',
      zone: 'AlMadinah',
      paymentStatus: 'Yet to receive',
      orderStatus: 'Order pending',
    },
    {
      requestorId: 'AB-004',
      requestorType: 'Corporate requestor',
      requestorName: 'Raja Vignesh',
      requestorMobile: '9876543210',
      requestDate: '2024-01-10',
      scheduledDate: '2024-02-20',
      dumpsterName: 'Dumpster D',
      city: 'Houston',
      zone: 'AlAndulas',
      paymentStatus: 'Payment received',
      orderStatus: 'Order Placed',
    },
  ];
  activeDropdown: any;

  constructor(
    private modalService: NgbModal,
    private orderService: OrderManagementService,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private spinner: NgxSpinnerService,
    private masterService: MasterInformationService
  ) {
    this.orderForm = this.fb.group({
      userType: ['', { disabled: true }],
      companyName: ['', { disabled: true }],
      mobileNumber: ['', { disabled: true }],
      location: ['', { disabled: true }],
      email: ['', { disabled: true }],
      city: ['', { disabled: true }],
      zone: ['', { disabled: true }],
      reqDate: ['', { disabled: true }],
      scheduledDate: ['', { disabled: true }],
      containerName: ['', { disabled: true }],
      containerCapacity: ['', { disabled: true }],
      containerCount: ['', { disabled: true }],
      rentalDuration: ['', { disabled: true }],
      sar: ['', { disabled: true }],
    });
  }

  ngOnInit() {
    this.getApproveOrder();
    this.getCityList();
  }

  // -------------------------------- Get Approve Order List API -------------------------------- //

  getApproveOrder() {
    this.orderService
      .getApproveOrderList(apiEndPoints.getApproveOrder)
      .subscribe({
        next: (response: any) => {
          this.approveOrderList = response.body.details.filter(
            (detail: any) => detail.currentOrderStatus == 'Review for Approval'
          );

          this.originalTableData = [...this.approveOrderList];
        },
        error: (error) => {
          this.toastService.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // -------------------------------- Post Approve Order Status API -------------------------------- //

  openConfirmationModal(row: any): void {
    if (row.currentOrderStatus === 'Order placed') {
      this.toastService.info('SAR Received from the Requestor', 'Info', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        progressBar: true,
      });
      return;
    }

    this.selectedOrderId = row.orderId;
    this.requestorName = row.requestorName;
    this.selectedRequestorId = row.requestorId;
    this.orderStatus = row.currentOrderStatus;
    this.modalService.open(this.confirmationModal, {
      ariaLabelledBy: 'confirmation-modal-title',
    });
  }

  // -------------------------------- Post Approve Order Status API -------------------------------- //

  postOrderStatus(modal: any) {
    const reqBody = {
      userid: this.selectedRequestorId,
      requestorStatusCode: 102,
      orderID: this.selectedOrderId,
    };
    console.log(reqBody);
    this.orderService
      .postApproveOrderStatus(apiEndPoints.orderStatus, reqBody)
      .subscribe({
        next: (response: any) => {
          modal.close();
          this.getApproveOrder();
          this.toastService.success('Order Placed Successfully', 'Success', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          });
        },
        error: (error) => {
          // If an error occurs from the backend
          console.error('API Error:', error);
          this.toastService.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // -------------------------------- View Details By Order ID -------------------------------- //

  openDetailModal(modal: any, row: any) {
    this.selectedOrderId = row.orderId;
    // Manual formatting of dates
    const formatDate = (date: string | null): string => {
      if (!date) return '';
      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
      };
      return new Intl.DateTimeFormat('en-GB', options).format(new Date(date));
    };
    
    const formattedReqDate = formatDate(row.requestDate);
    const formattedScheduledDate = formatDate(row.scheduledDate);

    // Patch the response data into the form
    this.orderForm.patchValue({
      userType: row.requestorType || '',
      companyName: row.requestorType == 'Individual Requester' ? row.requestorName : row.companyName || '',
      mobileNumber: row.requestorMobile || '',
      location: row.resquestorLocation || '',
      email: '',
      city: row.city || '',
      zone: row.zone || '',
      reqDate: formattedReqDate,
      scheduledDate: formattedScheduledDate,
      containerName: row.containerName || '',
      containerCapacity: row.containerCapacity || '',
      containerCount: row.containerCount || '',
      rentalDuration: row.rentalDuration || '',
      sar: row.sar || '',
    });

    this.modalService.open(modal, {
      ariaLabelledBy: 'confirmation-modal-title',
    });
  }

  // -------------------------------- Input Search Filter -------------------------------- //

  onSearch(event: any): void {
    const searchText = event.target.value?.toLowerCase() || '';

    if (!this.originalTableData) {
      this.originalTableData = [...this.approveOrderList];
    }
    if (searchText) {
      this.approveOrderList = this.originalTableData.filter(
        (item: any) =>
          item.orderId?.toLowerCase().includes(searchText) ||
          item.requestorName?.toLowerCase().includes(searchText) ||
          item.requestorMobile?.toLowerCase().includes(searchText) ||
          item.city?.toLowerCase().includes(searchText) ||
          item.zone?.toLowerCase().includes(searchText)
      );
    } else {
      this.approveOrderList = [...this.originalTableData];
    }
  }

  availableFilters: { [key: string]: string[] } = {
    requestorType: ['Corporate Requestor', 'Individual Requestor'],
    City: ['New York', 'Francisco', 'Chicago', 'Houston'],
    Zone: ['AlMadinah', 'AlAndulas'],
    Category: ['Order closed', 'Cancelled order', 'Active order'],
    'Order Status': ['Order Placed', 'Order pending'],
  };

  filteredTableData = [...this.tableData];

  toggleDropdown(header: string): void {
    this.activeDropdown = this.activeDropdown === header ? null : header;
  }

  applyFilter(event: any, header: string): void {
    const selectedOption = event.target.innerText;
    this.activeDropdown = null;

    if (!this.originalTableData) {
      this.originalTableData = [...this.filteredTableData];
    }

    if (selectedOption) {
      this.filteredTableData = this.originalTableData.filter((item: any) => {
        const key = header.toLowerCase();
        const value = item[key];
        console.log(value);
        return value?.toLowerCase().includes(selectedOption.toLowerCase());
      });
    } else {
      this.filteredTableData = [...this.originalTableData];
    }
  }

  clearFilter() {
    this.filteredTableData = [...this.tableData];
  }

  getCityList() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        if (response.body.details) {
          this.cities = response.body.details;
        } else {
          this.cities = [];
        }

        this.cities.forEach((city: any) => {
          if (!this.uniqueCities.includes(city.cityName)) {
            this.uniqueCities.push(city.cityName);
          }
        });
      },
      error: (err: any) => {
        console.log(err);
      },
    });
  }

  filterData(type = '', city: any = '') {
    if (type == 'All') {
      this.approveOrderList = this.originalTableData;
    } else {
      this.approveOrderList = this.originalTableData.filter(
        (data: any) => data.city == city
      );
    }
  }
}
